import React from "react";
import { Link } from "react-router-dom";
import { Calendar, Fuel, Gauge, MapPin, Settings2, Star } from "lucide-react";
import { INR, KM } from "../lib/gj";

export default function CarCard({ car, featured = false }) {
  const img =
    (car.images && car.images[0]) ||
    "https://images.unsplash.com/photo-1542362567-b07e54358753?w=900";

  return (
    <Link
      to={`/cars/${car.id}`}
      data-testid={`car-card-${car.id}`}
      className="group bg-white rounded-xl border border-[#0A192F]/10 overflow-hidden gj-shadow-card hover:-translate-y-1 transition-all duration-300 block"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-[#F3F0EA]">
        <img
          src={img}
          alt={`${car.brand} ${car.model}`}
          loading="lazy"
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        {(featured || car.is_featured) && (
          <span className="absolute top-3 left-3 inline-flex items-center gap-1 bg-[#F97316] text-[#0A192F] text-[10px] uppercase tracking-[0.18em] font-bold px-2 py-1 rounded">
            <Star className="w-3 h-3" /> Featured
          </span>
        )}
        <span className="absolute top-3 right-3 bg-white/95 text-[#0A192F] text-xs font-medium px-2 py-1 rounded">
          {car.year}
        </span>
      </div>

      <div className="p-5">
        <div className="flex items-center justify-between">
          <div className="text-xs uppercase tracking-[0.18em] text-[#718096] font-medium">
            {car.brand}
          </div>
          <div className="text-xs text-[#718096] flex items-center gap-1">
            <MapPin className="w-3 h-3" /> {car.location}
          </div>
        </div>
        <h3 className="font-heading text-lg font-bold text-[#0A192F] mt-1 leading-tight line-clamp-1">
          {car.model}
        </h3>

        <div className="grid grid-cols-3 gap-2 mt-4 text-xs text-[#4A5568]">
          <div className="flex items-center gap-1">
            <Gauge className="w-3.5 h-3.5 text-[#0A192F]/60" /> {KM(car.km_driven)}
          </div>
          <div className="flex items-center gap-1">
            <Fuel className="w-3.5 h-3.5 text-[#0A192F]/60" /> {car.fuel_type}
          </div>
          <div className="flex items-center gap-1">
            <Settings2 className="w-3.5 h-3.5 text-[#0A192F]/60" /> {car.transmission?.slice(0, 4)}
          </div>
        </div>

        <div className="mt-5 flex items-end justify-between">
          <div>
            <div className="text-[10px] uppercase tracking-[0.18em] text-[#718096]">Price</div>
            <div className="font-heading text-xl font-extrabold text-[#0A192F]">
              {INR(car.price)}
            </div>
          </div>
          <span className="text-xs px-2.5 py-1 rounded bg-[#F3F0EA] text-[#0A192F] font-medium">
            View →
          </span>
        </div>
      </div>
    </Link>
  );
}
